import { BREAKOUT_NAMESPACE_ID } from 'src/constants';
import {
  STATUS_FUNDED,
  STATUS_ACTIVE_OFFER,
  STATUS_DECLINED,
  STATUS_SAVED_PREQUALIFICATION,
  STATUS_APPLICATION_SUBMITTED,
  STATUS_ACCEPTED,
  STATUS_INCOMPLETE_FOLLOWUP,
  STATUS_UNDERWRITING_UNDER_REVIEW,
  STATUS_UNDERWRITING_BR_OCROLUS,
  STATUS_UNDERWRITING_PENDING_APPROVAL,
  STATUS_CONTRACT_SENT,
  STATUS_CLOSING,
  STATUS_EXPIRED_OFFERS,
  STATUS_ELIGIBLE,
  STATUS_UNDERWRITING,
  APPLICANT,
  STATUS_HIGHCREST_SUBMISSION,
  STATUS_OFFER_PENDING,
  STATUS_FACTOR,
  STATUS_INVITATION_SENT,
} from 'src/services/constants';
import { MERCHANTCASHADVANCES } from 'src/features/LoansHome/Products/constants';
import {
  SMARTMATCH_TYPE_LOAN_PROCESSOR,
  SMARTMATCH_TYPE_LOAN_OFFICER,
  SMARTMATCH_TYPE_UNDER_WRITER
} from 'src/services/constants';
import {
  USER_ONBOARD_ADMIN_UNDERWRITER,
  USER_ONBOARD_ADMIN,
  USER_ONBOARD_ACCOUNTING,
  USER_ONBOARD_HIGH_CREST,
  USER_ONBOARD_SALES,
  USER_ONBOARD_SALES_ADMIN,
} from 'src/services/constants/accounts';


const mkBreakoutLoanStagesForApplicant = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPLICATION_SUBMITTED,
            "display_name": STATUS_APPLICATION_SUBMITTED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_UNDERWRITING,
            "display_name": STATUS_UNDERWRITING
          },
          {
            "name": STATUS_ACTIVE_OFFER,
            "display_name": STATUS_ACTIVE_OFFER
          },
          {
            "name": STATUS_CLOSING,
            "display_name": STATUS_CLOSING
          },
          {
            "name": STATUS_FUNDED,
            "display_name": STATUS_FUNDED
          },
          {
            "name": STATUS_ELIGIBLE,
            "display_name": STATUS_ELIGIBLE
          }
        ]
      }
    ],
    "name": STATUS_SAVED_PREQUALIFICATION,
    "display_name": STATUS_SAVED_PREQUALIFICATION
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_APPLICATION_SUBMITTED,
    "display_name": STATUS_APPLICATION_SUBMITTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_DECLINED,
    "display_name": STATUS_DECLINED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_UNDERWRITING,
    "display_name": STATUS_UNDERWRITING
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_ACTIVE_OFFER,
    "display_name": STATUS_ACTIVE_OFFER
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_CLOSING,
    "display_name": STATUS_CLOSING
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_FUNDED,
    "display_name": STATUS_FUNDED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_ELIGIBLE,
    "display_name": STATUS_ELIGIBLE
  }
]

const mkBreakoutLoanStages = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPLICATION_SUBMITTED,
            "display_name": STATUS_APPLICATION_SUBMITTED
          },
          {
            "name": STATUS_INVITATION_SENT,
            "display_name": STATUS_INVITATION_SENT
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_SAVED_PREQUALIFICATION,
    "display_name": STATUS_SAVED_PREQUALIFICATION
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_ACCEPTED,
            "display_name": STATUS_ACCEPTED,
            "options": {
              "conditions": [STATUS_UNDERWRITING],
              "phase": STATUS_UNDERWRITING
            }
          },
          {
            "name": STATUS_UNDERWRITING,
            "display_name": STATUS_UNDERWRITING
          },
          {
            "name": STATUS_INCOMPLETE_FOLLOWUP,
            "display_name": STATUS_INCOMPLETE_FOLLOWUP
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_SUBMITTED,
    "display_name": STATUS_APPLICATION_SUBMITTED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_INVITATION_SENT,
    "display_name": STATUS_INVITATION_SENT
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_DECLINED,
    "display_name": STATUS_DECLINED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_ACCEPTED,
    "display_name": STATUS_ACCEPTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_UNDERWRITING_BR_OCROLUS,
            "display_name": STATUS_UNDERWRITING_BR_OCROLUS
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_UNDERWRITING,
    "display_name": STATUS_UNDERWRITING
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_INCOMPLETE_FOLLOWUP,
    "display_name": STATUS_INCOMPLETE_FOLLOWUP
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_UNDERWRITING_UNDER_REVIEW,
            "display_name": STATUS_UNDERWRITING_UNDER_REVIEW
          },
          {
            "name": STATUS_FACTOR,
            "display_name": STATUS_FACTOR
          }
        ]
      }
    ],
    "name": STATUS_UNDERWRITING_BR_OCROLUS,
    "display_name": STATUS_UNDERWRITING_BR_OCROLUS
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_HIGHCREST_SUBMISSION,
            "display_name": STATUS_HIGHCREST_SUBMISSION
          },
          {
            "name": STATUS_ACTIVE_OFFER,
            "display_name": STATUS_ACTIVE_OFFER
          },
          {
            "name": STATUS_UNDERWRITING_PENDING_APPROVAL,
            "display_name": STATUS_UNDERWRITING_PENDING_APPROVAL
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_UNDERWRITING_UNDER_REVIEW,
    "display_name": STATUS_UNDERWRITING_UNDER_REVIEW
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_FACTOR,
    "display_name": STATUS_FACTOR
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_ACTIVE_OFFER,
            "display_name": STATUS_ACTIVE_OFFER
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_CONTRACT_SENT,
            "display_name": STATUS_CONTRACT_SENT
          },
          {
            "name": STATUS_EXPIRED_OFFERS,
            "display_name": STATUS_EXPIRED_OFFERS
          }
        ]
      }
    ],
    "name": STATUS_HIGHCREST_SUBMISSION,
    "display_name": STATUS_HIGHCREST_SUBMISSION
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_ACTIVE_OFFER,
            "display_name": STATUS_ACTIVE_OFFER
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_ACTIVE_OFFER,
    "display_name": STATUS_ACTIVE_OFFER
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_UNDERWRITING_PENDING_APPROVAL,
    "display_name": STATUS_UNDERWRITING_PENDING_APPROVAL
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_CONTRACT_SENT,
    "display_name": STATUS_CONTRACT_SENT
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_EXPIRED_OFFERS,
    "display_name": STATUS_EXPIRED_OFFERS
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_FUNDED,
            "display_name": STATUS_FUNDED
          }
        ]
      }
    ],
    "name": STATUS_CLOSING,
    "display_name": STATUS_CLOSING
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_ELIGIBLE,
            "display_name": STATUS_ELIGIBLE
          }
        ]
      }
    ],
    "name": STATUS_FUNDED,
    "display_name": STATUS_FUNDED
  },
  {
    "children": [
      {
        "stages": []
      }
    ],
    "name": STATUS_ELIGIBLE,
    "display_name": STATUS_ELIGIBLE
  }
]

const mkBreakoutLoanStagesForAdmin = [
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_APPLICATION_SUBMITTED,
            "display_name": STATUS_APPLICATION_SUBMITTED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_SAVED_PREQUALIFICATION,
    "display_name": STATUS_SAVED_PREQUALIFICATION
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_ACCEPTED,
            "display_name": STATUS_ACCEPTED,
            "options": {
              "conditions": [STATUS_UNDERWRITING],
              "phase": STATUS_UNDERWRITING
            }
          },
          {
            "name": STATUS_INCOMPLETE_FOLLOWUP,
            "display_name": STATUS_INCOMPLETE_FOLLOWUP
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_APPLICATION_SUBMITTED,
    "display_name": STATUS_APPLICATION_SUBMITTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_UNDERWRITING,
            "display_name": STATUS_UNDERWRITING
          },
          {
            "name": STATUS_APPLICATION_SUBMITTED,
            "display_name": STATUS_APPLICATION_SUBMITTED
          },
          {
            "name": STATUS_SAVED_PREQUALIFICATION,
            "display_name": STATUS_SAVED_PREQUALIFICATION
          }
        ]
      }
    ],
    "name": STATUS_DECLINED,
    "display_name": STATUS_DECLINED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_HIGHCREST_SUBMISSION,
            "display_name": STATUS_HIGHCREST_SUBMISSION
          }
        ]
      }
    ],
    "name": STATUS_ACCEPTED,
    "display_name": STATUS_ACCEPTED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_UNDERWRITING,
            "display_name": STATUS_UNDERWRITING
          },
          {
            "name": STATUS_APPLICATION_SUBMITTED,
            "display_name": STATUS_APPLICATION_SUBMITTED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_INCOMPLETE_FOLLOWUP,
    "display_name": STATUS_INCOMPLETE_FOLLOWUP
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_UNDERWRITING_UNDER_REVIEW,
            "display_name": STATUS_UNDERWRITING_UNDER_REVIEW
          }
        ]
      }
    ],
    "name": STATUS_UNDERWRITING,
    "display_name": STATUS_UNDERWRITING
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_ACTIVE_OFFER,
            "display_name": STATUS_ACTIVE_OFFER
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_HIGHCREST_SUBMISSION,
    "display_name": STATUS_HIGHCREST_SUBMISSION
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_FACTOR,
            "display_name": STATUS_FACTOR
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_INCOMPLETE_FOLLOWUP,
            "display_name": STATUS_INCOMPLETE_FOLLOWUP
          },
          {
            "name": STATUS_ACTIVE_OFFER,
            "display_name": STATUS_ACTIVE_OFFER
          },
          {
            "name": STATUS_OFFER_PENDING,
            "display_name": STATUS_OFFER_PENDING
          }
        ]
      }
    ],
    "name": STATUS_UNDERWRITING_UNDER_REVIEW,
    "display_name": STATUS_UNDERWRITING_UNDER_REVIEW
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_CONTRACT_SENT,
            "display_name": STATUS_CONTRACT_SENT
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_ACTIVE_OFFER,
    "display_name": STATUS_ACTIVE_OFFER
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          },
          {
            "name": STATUS_INCOMPLETE_FOLLOWUP,
            "display_name": STATUS_INCOMPLETE_FOLLOWUP
          },
          {
            "name": STATUS_ACTIVE_OFFER,
            "display_name": STATUS_ACTIVE_OFFER
          },
          {
            "name": STATUS_OFFER_PENDING,
            "display_name": STATUS_OFFER_PENDING
          }
        ]
      }
    ],
    "name": STATUS_FACTOR,
    "display_name": STATUS_FACTOR
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_ACTIVE_OFFER,
            "display_name": STATUS_ACTIVE_OFFER
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_OFFER_PENDING,
    "display_name": STATUS_OFFER_PENDING
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_CLOSING,
            "display_name": STATUS_CLOSING
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_CONTRACT_SENT,
    "display_name": STATUS_CONTRACT_SENT
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_FUNDED,
            "display_name": STATUS_FUNDED
          },
          {
            "name": STATUS_DECLINED,
            "display_name": STATUS_DECLINED
          }
        ]
      }
    ],
    "name": STATUS_CLOSING,
    "display_name": STATUS_CLOSING
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_ELIGIBLE,
            "display_name": STATUS_ELIGIBLE
          }
        ]
      }
    ],
    "name": STATUS_FUNDED,
    "display_name": STATUS_FUNDED
  },
  {
    "children": [
      {
        "stages": [
          {
            "name": STATUS_FUNDED,
            "display_name": STATUS_FUNDED
          }
        ]
      }
    ],
    "name": STATUS_ELIGIBLE,
    "display_name": STATUS_ELIGIBLE
  }
]



const BREAKOUT_LOAN_STAGES_CONFIG = {
  id: '154878745215745754',
  namespace_id: BREAKOUT_NAMESPACE_ID,
  loan_type: [MERCHANTCASHADVANCES],
  sub_loan_types: [MERCHANTCASHADVANCES],
  stages: mkBreakoutLoanStages,
  roles: [SMARTMATCH_TYPE_LOAN_OFFICER, USER_ONBOARD_HIGH_CREST],
};

const BREAKOUT_LOAN_STAGES_FOR_ADMINS_CONFIG = {
  id: '154878745215745754',
  namespace_id: BREAKOUT_NAMESPACE_ID,
  loan_type: [MERCHANTCASHADVANCES],
  sub_loan_types: [MERCHANTCASHADVANCES],
  stages: mkBreakoutLoanStagesForAdmin,
  roles: [
    USER_ONBOARD_ADMIN_UNDERWRITER,
    USER_ONBOARD_ADMIN,
    SMARTMATCH_TYPE_UNDER_WRITER,
    SMARTMATCH_TYPE_LOAN_PROCESSOR,
    USER_ONBOARD_ACCOUNTING,
    USER_ONBOARD_SALES,
    USER_ONBOARD_SALES_ADMIN
  ],
};

const BREAKOUT_APPLICANT_LOAN_STAGES_CONFIG = {
  id: '154878745215745754',
  namespace_id: BREAKOUT_NAMESPACE_ID,
  loan_type: [MERCHANTCASHADVANCES],
  sub_loan_types: [MERCHANTCASHADVANCES],
  stages: mkBreakoutLoanStagesForApplicant,
  roles: [APPLICANT],
};


export const breakoutLoanStages = [
  BREAKOUT_LOAN_STAGES_CONFIG,
  BREAKOUT_LOAN_STAGES_FOR_ADMINS_CONFIG,
  BREAKOUT_APPLICANT_LOAN_STAGES_CONFIG
]